import AdminApi from './AdminApi';
import IAdminApi from './IAdminApi';

const adminApi: IAdminApi = new AdminApi();

export { adminApi as AdminApi };
